import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { CommunityUserFeed, FeedLikeType, UserFeedsType } from "../../types";

// interface CommunityFeedsState {
//   CommunityFeeds: any;
// }
type CommunityFeedType = {
  content: string;
  id: string;
  updatedAt: string;
  createdAt: string;
  mediaUrl: string[];
  creator: {
    id: string;
    email: string;
    username: string;
    roles: string;
  };
  community: {
    id: string;
    name: string;
  };
  comments: {
    comments: string;
    creator: {
      id: string;
      email: string;
      username: string;
      roles: string;
    };
    commmunityFeed: {
      id: string;
    };
    id: string;
    createdAt: string;
    updatedAt: string;
  }[];
  feedLikes: {
    communityFeed: {
      id: string;
      content: string;
      mediaUrl: {
        imageUrl: string[];
        videoUrl: string[];
      }[];
      updatedAt: string;
      createdAt: string;
      creator: {
        id: string;
        username: string;
        lastName: string;
        firstName: string;
      };
      feedLikes: {
        likedBy: {
          id: string;
          username: string;
          firstName: string;
          lastName: string;
        };
        id: string;
      }[];
    };
    id: string;
    likedBy: {
      id: string;
      username: string;
      firstName: string;
      lastName: string;
    };
    userFeed: {
      content: string;
      createdAt: string;
      id: string;
      creator: {
        id: string;
        username: string;
        lastName: string;
        firstName: string;
      };
      media: {
        imageUrl: string[];
        videoUrl: string[];
      }[];
    };
  }[];
};

// type ChatType = {
//   id: string;
//   name: string;
//   profileImage: string;
// }
interface CommunityFeedTypeState {
  CommunityFeeds: CommunityFeedType[];
  chatWith: any;
  likedPost: any;
  UserFeeds: UserFeedsType[];
  CommunityUserFeeds: CommunityUserFeed[]
  userFeedLike: FeedLikeType[];
}

// const initialState: CommunityFeedsState = {
//   CommunityFeeds: null
// }

const initialState: CommunityFeedTypeState = {
  CommunityFeeds: [],
  chatWith: null,
  likedPost: [],
  UserFeeds: [],
  CommunityUserFeeds: [],
  userFeedLike: [],
};

const addCommunityFeedsSlice = createSlice({
  name: "communityFeed",
  initialState,
  reducers: {
    setCommunityFeeds: (state, action: PayloadAction<any>) => {
      state.CommunityFeeds = action.payload;
    },
    setChatWith: (state, action: PayloadAction<any>) => {
      state.chatWith = action.payload;
    },
    setLikedPost: (state, action: PayloadAction<any>) => {
      state.likedPost = action.payload;
    },
    setUserOnlyFeeds: (state, action: PayloadAction<any>) => {
      state.UserFeeds = action.payload;
    },
    setCommunityUserFeeds: (state, action: PayloadAction<any>) => {
      state.CommunityUserFeeds = action.payload
    },
    setUserFeedLike: (state, action: PayloadAction<any>) => {
      state.userFeedLike = action.payload;
    },
  },
});

export const {
  setCommunityFeeds,
  setChatWith,
  setLikedPost,
  setUserOnlyFeeds,
  setCommunityUserFeeds,
  setUserFeedLike,
} = addCommunityFeedsSlice.actions;

export default addCommunityFeedsSlice.reducer;
